import axiosHttp from "./interceptor.service";

// Create earned leave request
export const createEarnedLeaveRequest = (userId, data) => {
  return axiosHttp.post(`/lmt/earnedLeaveRequest/${userId}`, data);
};

// Get all earned leave requests (admin)
export const getAllEarnedLeaveRequests = (params) => {
  return axiosHttp.get("/lmt/earnedLeaveRequests", { params });
};

// Get earned leave requests by user ID (employee)
export const getEarnedLeaveRequestsByUserId = (userId) => {
  return axiosHttp.get(`/lmt/earnedLeaveRequest/${userId}`);
};

// Get earned leave history for summary
export const getEarnedLeaveHistoryForSummary = (userId, params) => {
  return axiosHttp.get(`/lmt/getEarnedLeaveHistoryForSummary/${userId}`, { params });
};

// Update earned leave request status (approve/reject)
export const updateEarnedLeaveRequestStatus = (requestId, data) => {
  return axiosHttp.put(`/lmt/earnedLeaveRequest/${requestId}`, data);
};

// Delete earned leave request
export const deleteEarnedLeaveRequest = (requestId) => {
  return axiosHttp.delete(`/lmt/earnedLeaveRequest/${requestId}`);
};
